<template>
    <div class="w-100 mt-5">
        <div class="row">
            <div class="col-4 col-md-4 col-lg-4 col-xl-4">
                <CardInfo title="Store Name" :cardData="dataSeller[0]" />
            </div>
            <div class="col-3 col-md-3 col-lg-3 col-xl-3">
                <CardInfo title="Orders Created" :cardData="dataSeller[1]" />
            </div>
            <div class="col-3 col-md-3 col-lg-3 col-xl-3">
                <CardInfo title="Review Given" :cardData="dataSeller[2]" />
            </div>
        </div>
        <div class="row">
            <div class="card text-start p-3 m-2">
                <div class="row">
                    <div class="col-lg-6 me-5">
                        <p class="fw-bold">Basic Info</p>
                        <div class="mb-3 row">
                            <label class="col-sm-3 col-form-label">Full Name</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="fullname" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="email" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 row">
                            <label class="col-sm-3 col-form-label">Phone Number</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="phone" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 row">
                            <p class="text-end fw-bold">Join Date : {{filters.dateSimple(joinDate) }}</p>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <p class="fw-bold">Paxel Username</p>
                        <div class="row">
                            <p class="fw-bold fsize-14" style="color: #5E50A1;">{{fullname}}</p>
                        </div>
                        <div class="row">
                            <p class="fsize-12">{{username}}</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CardInfo from "@/components/CardInfo.vue";
    export default {
        components: {
            CardInfo
        },
        created() {
            const listRoute = this.$route.path.split("/");
            this.id = listRoute[listRoute.length - 1]
        },
        data() {
            return {
                id: "",
                fullname: "",
                username : "",
                email: "",
                phone : "",
                address : {},
                joinDate : "",
                dataSeller: [{
                        value: '-',
                        color: "red",
                    },
                    {
                        value: 0,
                        color: "green",
                    },
                    {
                        value: 0,
                        color: "yellow",
                    },
                ],
            }
        },
        methods: {

            async getData() {
                const response = await this.$store.dispatch("buyer/getById", this.id)
                const data = response.data.data
                this.fullname = data.Buyer.name
                this.username = data.Buyer.username
                this.email = data.Buyer.email
                this.phone = data.Buyer.phone_number
                this.joinDate = data.Buyer.created_date 
                this.dataSeller[0].value = data.Seller ? data.Seller.store_name : "-"
                this.dataSeller[1].value = data.CountOrder
                this.dataSeller[2].value = data.CountReviewGiven 
            }
        },
        mounted() {
            this.getData()
        },
    }
</script>

<style>
    .error-border {
        border: 1px red solid !important;
    }
</style>